import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { setupUSLocale } from './utils/localeSetup';

// Context
import { AuthProvider } from './contexts/AuthContext';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import PrivateRoute from './components/PrivateRoute';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

import Dashboard from './pages/Dashboard';
import Tournaments from './pages/Tournaments';
import About from './pages/About';
import Contact from './pages/Contact';
import SiteRules from './pages/SiteRules';
import ResponsibleGaming from './pages/ResponsibleGaming';
import Golfers from './pages/Golfers';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import TournamentDetails from './pages/TournamentDetails';
import LiveBetting from './pages/LiveBetting';
import Profile from './pages/Profile';

import AdminApp from './components/admin/AdminApp';
import BuyCredit from './pages/BuyCredit';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/700.css';
import '@fontsource/oswald/400.css';
import '@fontsource/oswald/700.css';

// Create a client
const queryClient = new QueryClient();

function App() {
  useEffect(() => {
    setupUSLocale();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/admin/*" element={<AdminApp />} />
            <Route path="/*" element={
              <div className="proskins-layout">
                <Header />
                <main className="proskins-main">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/site-rules" element={<SiteRules />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password/:token" element={<ResetPassword />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/golfers/" element={<Golfers />} />
                    <Route path="/responsible-gaming" element={<ResponsibleGaming />} />
                    <Route path="/dashboard" element={
                      <PrivateRoute>
                        <Dashboard />
                      </PrivateRoute>
                    } />
                    <Route path="/tournaments" element={
                      <PrivateRoute>
                        <Tournaments />
                      </PrivateRoute>
                    } />
                    <Route path="/tournaments/:id" element={
                      <PrivateRoute>
                        <TournamentDetails />
                      </PrivateRoute>
                    } />
                    <Route path="/betting" element={
                      <PrivateRoute>
                        <LiveBetting />
                      </PrivateRoute>
                    } />
                    <Route path="/profile" element={
                      <PrivateRoute>
                        <Profile />
                      </PrivateRoute>
                    } />
                    <Route path="/buy-credit" element={
                      <PrivateRoute>
                        <BuyCredit />
                      </PrivateRoute>
                    } />
                    <Route path="/live-betting" element={
                      <PrivateRoute>
                        <LiveBetting />
                      </PrivateRoute>
                    } />
                  </Routes>
                </main>
                <Footer />
                <Toaster position="top-right" />
              </div>
            } />
          </Routes>
        </AuthProvider>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
